import { Outlet, useParams } from "react-router";
import { createContext, useContext, useEffect, useState } from "react";
// import { IDisributorInfoExtend, IPartnerExtend } from "./DistributorDetail";
import { apiRemote } from "@/api/wp-api";
import { useAlert } from "@/contexts/AlertContext";
import { decodeId } from "@/utils/decodeId";
import { useCustomBreadcrumb } from "@/contexts/CustomBreadcrumb";
import { IUserOrder } from "@/api";
import { IUserOrderExtend } from "./MyOrders";

export interface UserOrderContextType {
    getUserOrder: () => Promise<any>;
}
const UserOrderContext=createContext<UserOrderContextType>({} as any);

export function UserOrderLayout(){
    const { id } = useParams<{ id: string }>(); 
    const alert=useAlert();
    const [userOrdersData, setUserOrdersData] = useState<IUserOrderExtend>({}as any);

    const getUserOrder=()=>{
        return apiRemote.getUserOrders().catch((err: any) => {
            alert.error(err.message);
            return {} as IUserOrderExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    useEffect(()=>{
        // alert.showWait();

        // Promise.all([orders]).then(([resOrders])=>{
        //     if (resOrders) {
        //         setUserOrdersData(resOrders.data)
        //     }
        // }).catch((err)=>{
        //     alert.error(err.message);
        // }).finally(()=>{
        //     alert.hideWait();
        // });



    },[id]);
    return (
        <UserOrderContext.Provider value={{getUserOrder}}>
            <Outlet />
        </UserOrderContext.Provider>
    )
}

export function useUserOrderContext(){
    return useContext(UserOrderContext);
}